import AuthBrandPanel from "@/components/Auth/AuthBrandPanel";
import AuthSplitLayout from "@/components/Auth/AuthSplitLayout";
import { getFirstTabPath, permittedTabs } from "@/components/Drawer/data";
import { BRAND, USER_TYPE } from "@/constants";
import { useUserContext } from "@/context/UserContext";
import routes from "@/routes";
import { Navigate } from "react-router-dom";
import LoginForm from "./LoginForm";

// Login serves every white-label brand, so panel copy must stay brand-agnostic.
const HEADLINE = "Welcome back";
const LEDE = `Sign in to ${BRAND.name} to pick up where you left off.`;

export default function Login({ isAdmin = false }: LoginProps) {
  const { user, isAuthenticated } = useUserContext();

  if (isAuthenticated) {
    const tabs =
      user &&
      permittedTabs(
        user?.Role?.$permissions,
        user?.Role?.name === USER_TYPE.SUPER_ADMIN
      );
    return <Navigate to={routes.DASHBOARD + "/" + getFirstTabPath(tabs)} />;
  }

  return (
    <AuthSplitLayout panel={<AuthBrandPanel headline={HEADLINE} lede={LEDE} />}>
      <LoginForm isAdmin={isAdmin} />
    </AuthSplitLayout>
  );
}

interface LoginProps {
  isAdmin?: boolean;
}
